import { createContext } from 'react'

import type { PaginationProps } from 'components/Table/Pagination'
import type { UseGetAuditLogs } from 'features/history/pages/ActivityLogPage/hooks/useGetAuditLogs'

export type ContextProps = Pick<UseGetAuditLogs, 'auditLogs' | 'loading'> & {
  pagination: PaginationProps
}

export const Context = createContext<ContextProps>({} as ContextProps)
